import config from 'config';
import { http_client } from './api';

const getList = async (query) => {
  return http_client.get(config.apiUrl + 'video', query).then((response) => {
    return response.data;
  });
};

const getListArchive = async (query) => {
  return http_client.get(config.apiUrl + 'video/archive', query).then((response) => {
    return response.data;
  });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'video', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'video/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.post(config.apiUrl + 'video/' + id, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'video/' + id).then((response) => {
    return response.data;
  });
};

const addFile = async (id, fileID) => {
  return http_client.post(config.apiUrl + 'video/' + id + '/file/' + fileID).then((response) => {
    return response.data;
  });
};

const delFile = async (id, fileID) => {
  return http_client.delete(config.apiUrl + 'video/' + id + '/file/' + fileID).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'video/' + id + '/status', data).then((response) => {
    return response.data;
  });
};

const getRatings = async (id, query) => {
  return http_client.get(config.apiUrl + 'video/' + id + '/ratings', query).then((response) => {
    return response.data;
  });
};

const getHistory = async (id, query) => {
  return http_client.get(config.apiUrl + 'video/' + id + '/history', query).then((response) => {
    return response.data;
  });
};

const getQuestionList = async (id, query = null) => {
  return http_client.get(config.apiUrl + 'video/' + id + '/question', query).then((response) => {
    return response.data;
  });
};

const getQuestionPreview = async (id) => {
  return http_client.get(config.apiUrl + 'video/' + id + '/question/preview').then((response) => {
    return response.data;
  });
};

const getSession = async (id, sessionId) => {
  return http_client.get(config.apiUrl + 'video/' + id + '/session/' + sessionId).then((response) => {
    return response.data;
  });
};

const storeQuestion = async (id, data) => {
  return http_client.post(config.apiUrl + 'video/' + id + '/question', data).then((response) => {
    return response.data;
  });
};

const getQuestion = async (id, questionId) => {
  return http_client.get(config.apiUrl + 'video/' + id + '/question/' + questionId).then((response) => {
    return response.data;
  });
};

const updateQuestion = async (id, questionId, data) => {
  return http_client.post(config.apiUrl + 'video/' + id + '/question/' + questionId, data).then((response) => {
    return response.data;
  });
};

const destroyQuestion = async (id, questionId) => {
  return http_client.delete(config.apiUrl + 'video/' + id + '/question/' + questionId).then((response) => {
    return response.data;
  });
};

const VideoService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  addFile,
  delFile,
  changeStatus,
  getRatings,
  getHistory,
  getQuestionList,
  storeQuestion,
  getQuestion,
  updateQuestion,
  destroyQuestion,
  getQuestionPreview,
  getSession
};

export default VideoService;
